<template>
	<select :disabled="this.disabled" v-model="current" class="form-control">
		<option v-for="cls in classes" :value="cls">{{String.fromCharCode(-1*cls+64).toUpperCase()}}</option>
	</select>
</template>

<script>
	export default {
		props: ['disabled', 'currentClass'],

		data() {
			return {
				classes: [],
				current: this.currentClass || 0
			}
		},

		watch: {
			current: function(val){
				this.$emit("he-change", val);
			},
			currentClass: function(val){
				this.current = val;
			}
		},

		created(){
			this.fetchClassInfo();
		},

		methods: {
			fetchClassInfo: function(){
				let vm = this;
				let res = axios.get("info/he")
								.then(res => {
									res = res.data;
									vm.classes = res.data;
									vm.current = res.data[0];
								});
			}
		}
	}
</script>